import { create } from "zustand";
import type { GoogleStatus } from "../../shared/googleAnalytics";
import { api } from "../lib/api";

export const useSearchConsole = create<{ status: GoogleStatus | null; error: string | null }>(() => ({ status: null, error: null }));
export async function loadSearchConsole(): Promise<GoogleStatus> {
  const status = await api<GoogleStatus>("/api/search-console/status");
  useSearchConsole.setState({ status, error: null });
  return status;
}
export async function searchConsoleProperties(): Promise<GoogleStatus> {
  const status = await api<GoogleStatus>("/api/search-console/properties", { body: {} });
  useSearchConsole.setState({ status, error: null });
  return status;
}
export async function selectSearchConsoleProperty(property: string): Promise<GoogleStatus> {
  const status = await api<GoogleStatus>("/api/search-console/property", { body: { property } });
  useSearchConsole.setState({ status, error: null });
  return status;
}
export async function disconnectSearchConsole(): Promise<void> {
  const status = await api<GoogleStatus>("/api/search-console/disconnect", { body: {} });
  useSearchConsole.setState({ status, error: null });
}
/** Open synchronously, so the browser treats it as the click the user made. */
export async function signInSearchConsole(): Promise<GoogleStatus> {
  const popup = window.open("about:blank", "cb-search-console-signin", "width=600,height=760");
  if (!popup) throw new Error("Allow a pop-up for Context Board, then try connecting Google again.");
  try {
    const result = await api<{ authorizeUrl: string }>("/api/search-console/start", { body: {} });
    const origin = window.location.origin;
    return await new Promise<GoogleStatus>((resolve, reject) => {
      let finished = false;
      const finish = async () => {
        if (finished) return;
        finished = true;
        clearInterval(poll); clearTimeout(deadline);
        window.removeEventListener("message", message);
        channel?.close();
        try {
          const status = await loadSearchConsole();
          if (!status.connected) reject(new Error("Google sign-in did not finish. Try again and allow read-only Search Console access."));
          else resolve(status);
        } catch (e) { reject(e); }
      };
      const message = (e: MessageEvent) => {
        if (e.origin !== origin || e.source !== popup || e.data?.type !== "cb:mcp-auth" || e.data?.provider !== "search-console") return;
        void finish();
      };
      const channel = typeof BroadcastChannel === "undefined" ? null : new BroadcastChannel("cb-mcp-auth");
      if (channel) channel.onmessage = (e) => { if (e.data?.provider === "search-console") void finish(); };
      const poll = setInterval(() => { if (popup.closed) void finish(); }, 700);
      const deadline = setTimeout(() => { popup.close(); void finish(); }, 15 * 60_000);
      window.addEventListener("message", message);
      popup.location.href = result.authorizeUrl;
    });
  } catch (e) { popup.close(); throw e; }
}
